var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"l-select__option",class:{
    'l-select__option--selected': _vm.isSelected,
    'l-select__option--hovered': _vm.index === _vm.select.aheadPointer
  },on:{"click":_vm.onSelect,"mouseover":_vm.onHover}},[_vm._v(_vm._s(_vm.label))])}
var staticRenderFns = []

export { render, staticRenderFns }